import { Inject, Injectable, Optional } from '@angular/core';
import { ClienteResponse, CustomerApiService, SituacaoCadastral, SituacaoCliente, TokenProviderService } from 'src/app/api';
import { map } from 'rxjs/operators';
import { PerfilService } from '../ajs-perfil.service';
import { CacheableGet } from './cacheable-get';
import { FIVE_MINUTES_IN_MILLIS, PROFILE_CACHE_TIME } from './consts';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  public get currentUser() {
    return this.ajsProfileService.getCacheUserData();
  }

  public get currentUserId(): number {
    return this.currentUser && this.currentUser.id || 0;
  }

  private customerDataRequest: CacheableGet<ClienteResponse>;

  constructor(
    private ajsProfileService: PerfilService,
    private customerApiService: CustomerApiService,
    tokenProviderService: TokenProviderService,
    @Optional() @Inject(PROFILE_CACHE_TIME) cacheTime: number,
  ) {
    if (!cacheTime) {
      cacheTime = FIVE_MINUTES_IN_MILLIS;
    }

    this.customerDataRequest = new CacheableGet<ClienteResponse>(
      cacheTime,
      () => this.customerApiService.getCustomerById(this.currentUserId),
    );

    tokenProviderService.user.subscribe(() => this.customerDataRequest.markForUpdate());
  }

  public getCustomerData() {
    return this.customerDataRequest.get();
  }

  public isActive() {
    return this.getCustomerData().pipe(
      map(customerData => customerData.situacaoCadastral === SituacaoCadastral.ATIVO && customerData.situacao !== SituacaoCliente.BLOQUEADO)
    );
  }
}
